import React from "react";

const principles = ["P1", "P2", "P3", "P4", "P5", "P6", "P7", "P8", "P9"];

const defaultFrequencyReviewRows = [
  {
    subject: "1. Performance against above policy and follow up action",
    frequencies: {},
  },
  {
    subject:
      "2. Meeting relevant legal requirements and correcting any violations.",
    frequencies: {},
  },
];

const ReviewFrequencyTable = ({ frequencyData, setFrequencyData }) => {
  const handleInputChange = (rowIndex, principle, value) => {
    const updated = [...frequencyData];
    updated[rowIndex].frequencies[principle] = value;
    setFrequencyData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Subject for Review</th>
            <th
              colSpan={9}
              style={{
                ...tableHeaderStyle,
                textAlign: "center",
              }}
            >
              Frequency (Annually / Half yearly / Quarterly / Any other – please
              specify)
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}></th>
            {principles.map((p) => (
              <th key={p} style={tableHeaderStyle}>
                {p}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {frequencyData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.subject}
              </td>
              {principles.map((principle) => (
                <td key={principle} style={tableCellStyle}>
                  <textarea
                    placeholder="Details"
                    value={row.frequencies?.[principle] || ""}
                    onChange={(e) =>
                      handleInputChange(rowIndex, principle, e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default ReviewFrequencyTable;
